<template>
  <div v-if="authStore.isRehydrating" class="flex items-center justify-center min-h-screen">
    <LoadingState message="Loading..." />
  </div>
  <div v-else class="flex min-h-screen bg-background">
    <AppSidebar v-if="authStore.isLoggedIn" />
    <div class="flex flex-col flex-1">
      <AppHeader v-if="authStore.isLoggedIn" />
      <main class="flex-1 p-6">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import LoadingState from '@/components/common/LoadingState.vue'

const authStore = useAuthStore()

onMounted(() => {
  authStore.rehydrate()
})
</script>
